<template>
  <v-app>
    <v-container>
      <v-card>
        <v-container>
          <v-card-title>Add Equipment
          <v-spacer></v-spacer>
          <v-btn to="/equipmentlist" icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          </v-card-title>
        </v-container>
      </v-card>
      <v-card>
        <v-container>
          <v-text-field
            label="Equipment Name"
            name="name"
            id="name"
            v-model="name"
            :rules="rule1"
            class="mx-4"
          >
          </v-text-field>
          <v-text-field
            label="Model"
            name="model"
            id="model"
            v-model="model"
            :rules="rule1"
            class="mx-4"
          >
          </v-text-field>
          <v-select
            label="Initial Quantity"
            name="quantity"
            id="quantity"
            v-model="quantity"
            type="number"
            class="mx-4"
            :items="getNumbers(100)"
          >
          </v-select>
          <v-btn
            class="ma-3 primary"
            @click="onPickFile"
          >
            Upload Image
          </v-btn>
          <input
            type="file"
            style="display: none"
            ref="fileInput"
            accept="image/*"
            @change="onFilePicked"
          >
          <v-img :src="imageUrl" height="150"></v-img>
        </v-container>
        <v-btn
          :disabled="!formIsValid"
          class="ma-2"
          color="green"
          @click="addEquipment()"
        >
          <v-icon left>mdi-plus</v-icon>
          Add Equipment
        </v-btn>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import * as moment from 'moment-timezone'
export default {
  title: 'Add Equipment',
  data () {
    return {
      name: '',
      quantity: '',
      model: '',
      image: null,
      imageUrl: '',
      rule1: [
        value => !!value || 'Required',
        value => (value || '').length <= 40 || 'Max 40 characters'
      ]
    }
  },
  methods: {
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      const filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
    },
    addEquipment () {
      if (!this.formIsValid) {
        return
      }
      if (!this.image) {
        return
      }
      const info = {
        name: this.name,
        quantity: this.quantity,
        image: this.image,
        model: this.model,
        date: [moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[0] + ' ' + moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[1].split('+')[0]]
      }
      console.log(info)
      this.$store.dispatch('createEquipment', info)
        .then(() => {
          this.$router.push('/equipmentlist')
        })
    },
    getNumbers (max) {
      var numbers = []
      for (var i = 0; i < max; i++) {
        numbers[i] = i + 1
      }
      return numbers
    }
  },
  computed: {
    formIsValid () {
      return this.name !== '' &&
      this.quantity !== '' &&
      this.model !== '' &&
      this.image !== null
    }
  }
}
</script>

<style>

</style>
